import styled from 'styled-components';
import { colorPallet } from 'src/styles/theme/colors';

export const ErrorPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 1.4rem;
  h1 {
    font-size: 1.2rem;
    font-weight: 700;
  }
  a {
    color: ${colorPallet.richBlue};
    cursor: pointer;
  }
  img {
    height: 150px;
    width: 150px;
  }
`;
